export const GUIAS_MOVIL = {
  value: 1,
  label: 'Móvil'
};
export const GUIAS_INTERNET = {
  value: 2,
  label: 'Internet'
};
export const GUIAS_ESPECTACULARES = {
  value: 3,
  label: 'Espectaculares'
};
export const GUIAS_VISITAS = {
  value: 4,
  label: 'Visitas de verificación'
};
export const GUIAS_REGISTROS = {
  value: 5,
  label: 'Registros'
};
export const GUIAS_GEOCERCAS = {
  value: 6,
  label: 'Geocercas'
};

export const GUIAS_MEDIOS_IMPRESOS = {
  value: 7,
  label: 'Medios impresos'
};
